import { MAP_TYPES } from '@deck.gl/carto';

const MIRAMARSTORMDRAINLINES_SOURCE_ID = 'miramarStormDrainLinesSource';

const source = {
  id: MIRAMARSTORMDRAINLINES_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.Miramar_Storm_Drainage_Lines`,
};

export default source;
